/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import Component from '@ember/component';
import { isEqual } from '@ember/utils';
import { run } from '@ember/runloop';
import merge from 'lodash.merge';
import cioParserRules from 'cio/helpers/wysiwyg/parser-rules';

@tagName('')
export default class Wysihtml5Editor extends Component {
  content = null;
  isTextArea = false;
  sentAttributes = null;
  toggleAction = null;

  @computed('id')
  get toolbarId() {
    return `${this.get('id')}-toolbar`;
  }

  didInsertElement() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let _self = this;
    let editor = (window.wysihtml5EditorInstance = new wysihtml5.Editor(this.get('id'), {
      stylesheets: [],
      toolbar: this.get('toolbarId'),
      parser: wysihtml5.dom.parse,
      parserRules: merge({}, wysihtml5ParserRules, cioParserRules),
    }));

    return editor.on('load', function () {
      return run(
        (function () {
          return function () {
            // Executes when there is a keyup event
            editor.composer.element.addEventListener('keyup', function () {
              return _self.set('content', editor.getValue());
            });
            // Executes when the editor blurs
            editor.on('change', function () {
              return _self.set('content', editor.getValue());
            });
            // Executes when a command is composed
            editor.on('aftercommand:composer', function () {
              return _self.set('content', editor.getValue());
            });
            // Executes when the view of the editor is changed
            return editor.on('change_view', function () {
              return _self.set('isTextArea', isEqual(editor.currentView, editor.textarea));
            });
          };
        })(this),
      );
    });
  }

  willDestroyElement() {
    window.wysihtml5EditorInstance = null;
  }

  init() {
    super.init();
    // We need to do this in order for wysihtml5 to initialize properly
    // It has to do with when the element is properly inserted into the DOM
    if (!this.get('id')) {
      return this.set('id', 'wysihtml5');
    }
  }

  @action
  focus() {
    window.wysihtml5EditorInstance.currentView.element.focus();
  }

  @action
  toggleEditor() {
    return this.toggleAction();
  }
}
